import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Star, User } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface Avis {
  id: string;
  prenom: string;
  nom: string;
  date: string;
  note: number;
  commentaire: string;
}

const ReviewsSection = () => {
  const [avis, setAvis] = useState<Avis[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAvis = async () => {
      const { data, error } = await supabase
        .from('avis')
        .select('*')
        .order('date', { ascending: false })
        .limit(3);

      if (error) {
        console.error('Error fetching avis:', error);
      } else if (data) {
        setAvis(data);
      }
    };

    fetchAvis();
  }, []);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
  };

  if (avis.length === 0) return null;

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 max-w-7xl">
        <h2 className="text-3xl md:text-4xl font-serif font-semibold text-foreground mb-12 text-center">
          Ils parlent de nous...
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {avis.map((item) => (
            <Card key={item.id} className="p-6 shadow-warm bg-background">
              <div className="flex justify-center mb-3">
                <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center">
                  <User className="w-5 h-5 text-muted-foreground" />
                </div>
              </div>
              <div className="flex gap-1 mb-3 justify-center">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`w-4 h-4 ${
                      i < item.note
                        ? 'fill-primary text-primary'
                        : 'text-muted-foreground'
                    }`}
                  />
                ))}
              </div>
              <p className="text-foreground mb-4 text-sm text-center">{item.commentaire}</p>
              <p className="text-sm text-muted-foreground text-center">
                {item.prenom} {item.nom.charAt(0)}. - {formatDate(item.date)}
              </p>
            </Card>
          ))}
        </div>

        <div className="flex justify-center">
          <Button 
            onClick={() => {
              navigate('/avis');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            variant="outline"
            className="px-8"
          >
            Voir tous les avis
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
